module.exports = __webpack_public_path__ + "static/media/marth_0.49f99196.png";